module.exports = __webpack_public_path__ + "static/media/details-2-image-1.84586c26.jpg";